import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown, FaSignOutAlt, FaUser } from "react-icons/fa";
import { HiMiniBars3CenterLeft } from "react-icons/hi2";
import imgIcon from "../assets/images/userIcon.png";
import { useAuth } from "../Context/AuthContext";
import logo from "../assets/images/logo.png";
import { IoNotificationsOutline } from "react-icons/io5";
import "../Styling/Topbar.css";
import { toast } from "react-toastify";
import {
  getPendingLeaves,
  getPendingWFH,
  approveLeave,
  rejectLeave,
  approveWFH,
  rejectWFH
} from "../Api/LeaveInboxApi";


const Topbar = () => {
  const navigate = useNavigate();
  const { logout, user } = useAuth(); // ✅ single source of truth

  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const userDropdownRef = useRef(null);
  const [showInbox, setShowInbox] = useState(false);
  const [pendingRequests, setPendingRequests] = useState([]);
  const inboxRef = useRef(null);
const isHR = Array.isArray(user.roles) && user.roles.includes("HR");
  const toggleUserDropdown = () => {
    setShowUserDropdown((prev) => !prev);
  };

  const handleLogout = () => {
    setShowUserDropdown(false);
    logout(); // clears state + storage + redirect
  };

  const handleProfileButton = () => {
    setShowUserDropdown(false);
    navigate("/profile-page");
  };

  const handleToggleSideBar = () => {
    console.log("clicked");
    document.body.classList.toggle("toggle-sidebar");
  };

  const formatShortDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleDateString("en-GB", {
    day: "numeric",
    month: "short"
  });
};
const handleAction = async (item, action) => {
  try {
    const token = user.token;

    if (item.type === "Leave") {
      if (action === "approve") {
        await approveLeave(item.id, token);
        toast.success("Leave Approved ✅");
      } else {
        await rejectLeave(item.id, token);
        toast.info("Leave Rejected ❌");
      }
    } else {
      if (action === "approve") {
        await approveWFH(item.id, token);
        toast.success("WFH Approved ✅");
      } else {
        await rejectWFH(item.id, token);
        toast.info("WFH Rejected ❌");
      }
    }

    // remove from UI
    setPendingRequests(prev =>
      prev.filter(req => req.id !== item.id)
    );

  } catch (err) {
    console.error(err);
    toast.error("Action failed ❗");
  }
};

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        userDropdownRef.current &&
        !userDropdownRef.current.contains(event.target)
      ) {
        setShowUserDropdown(false);
      }
    };

    const handleEsc = (event) => {
      if (event.key === "Escape") setShowUserDropdown(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("keydown", handleEsc);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("keydown", handleEsc);
    };
  }, []);

useEffect(() => {
  if (!isHR || !user) return;
  

  const fetchPending = async () => {
    try {
      const orgId = user.organisationId;
      const token = user.token;

      const [leaveRes, wfhRes] = await Promise.all([
        getPendingLeaves(orgId, token),
        getPendingWFH(orgId, token)
      ]);

      const leaves = leaveRes.data || [];
      const wfhData = wfhRes.data?.data || wfhRes.data || [];

      // ✅ Only pending WFH
      const pendingWFH = wfhData.filter(x => x.leaveStatus === "Pending");

      const formattedLeaves = leaves.map(l => ({
        id: l.leaveId,
        name: l.userName,
        type: "Leave",
        start: l.leaveDate,
        end: l.endLeaveDate,
        status: l.leaveStatus
      }));

      const formattedWFH = pendingWFH.map(w => ({
        id: w.leaveId,
        name: w.resourceName,
        type: "WFH",
        start: w.leaveDate,
        end: w.endLeaveDate,
        status: w.leaveStatus
      }));

      setPendingRequests([...formattedLeaves, ...formattedWFH]);

    } catch (err) {
      console.error("Error fetching pending requests", err);
    }
  };

  fetchPending();
}, [user]);

useEffect(() => {
  const handleClickOutside = (event) => {
    // close user dropdown
    if (
      userDropdownRef.current &&
      !userDropdownRef.current.contains(event.target)
    ) {
      setShowUserDropdown(false);
    }

    // ✅ close inbox
    if (
      inboxRef.current &&
      !inboxRef.current.contains(event.target)
    ) {
      setShowInbox(false);
    }
  };

  const handleEsc = (event) => {
    if (event.key === "Escape") {
      setShowUserDropdown(false);
      setShowInbox(false);
    }
  };

  document.addEventListener("mousedown", handleClickOutside);
  document.addEventListener("keydown", handleEsc);

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
    document.removeEventListener("keydown", handleEsc);
  };
}, []);
  // ⛔ Do not render Topbar user menu until user is ready
  if (!user) return null;

  return (
    <div className="dashboard-header">
      {/* LEFT */}
      <div className="header-left">
        <button className="menu-button" onClick={handleToggleSideBar}>
          <HiMiniBars3CenterLeft className="bar-icon" />
        </button>
      </div>

      {/* CENTER */}
      <div className="header-center">

        <div
          onClick={() => navigate("/home")}
          style={{
            display: "flex",
            alignItems: "center",
            gap: "8px",
            cursor: "pointer",
          }}
        >
          <img
            src="https://userrdocument.blob.core.windows.net/userdocument/companylogos/9001/3000/fe7c8f45-0332-44f9-aafa-317d66b3a66a_MAVR logo with pie chart symbol.png"
            alt="Company Logo"
            style={{
              marginTop: "10px",
              height: "140px",
              width: "auto",
              objectFit: "contain",
            }}
          />
        </div>
      </div>

      {/* RIGHT */}
      <div className="header-right">
        {isHR && (
<div className="topbar-inbox-container" ref={inboxRef}>
  <button
    className="topbar-inbox-button"
    onClick={() => setShowInbox(prev => !prev)}
  >
<IoNotificationsOutline />

    {pendingRequests.length > 0 && (
      <span className="topbar-inbox-badge">
        {pendingRequests.length}
      </span>
    )}
  </button>

  {showInbox && (
    <div className="topbar-inbox-dropdown">
      {pendingRequests.length === 0 ? (
        <p className="topbar-inbox-empty">No pending requests</p>
      ) : (
        pendingRequests.map(item => (
          <div key={item.id} className="topbar-inbox-item">
            <div className="topbar-inbox-item-info">
              <strong className="topbar-inbox-employee">
                {item.name}
              </strong>
              <p className="topbar-inbox-type">{item.type}</p>
              <small className="topbar-inbox-dates">
{formatShortDate(item.start)} → {formatShortDate(item.end)}              </small>
            </div>

            <div className="topbar-inbox-actions">
              <button
                className="topbar-inbox-approve-btn"
                onClick={() => handleAction(item, "approve")}
              >
                Approve
              </button>
              <button
                className="topbar-inbox-reject-btn"
                onClick={() => handleAction(item, "reject")}
              >
                Reject
              </button>
            </div>
          </div>
        ))
      )}
    </div>
  )}
</div>
)}
        <div className="user-dropdown-container" ref={userDropdownRef}>
          <button className="user-button" onClick={toggleUserDropdown}>
            <img src={imgIcon} alt="user" className="img-fluid user-icon" />
            <span className="username">{user.username || user.email}</span>
            <FaChevronDown className="down-icon" />
          </button>

          {showUserDropdown && (
            <div className="user-dropdown">
              <div className="user-role">
                <p>
                  <strong>Name:</strong> {user.username || "-"}
                </p>
                <p>
                  <strong>Email:</strong> {user.email}
                </p>

                {/* ✅ SAFE roles rendering */}
                {Array.isArray(user.roles) && user.roles.length > 0 && (
                  <p>
                    <strong>Roles:</strong> {user.roles.join(", ")}
                  </p>
                )}
              </div>

              <button
                className="profile-dropdown-button"
                onClick={handleProfileButton}
              >
                <FaUser /> View Profile
              </button>

              <button className="logout-dropdown-button" onClick={handleLogout}>
                <FaSignOutAlt /> Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Topbar;

// import { useState, useEffect } from "react";
// import { useNavigate } from "react-router-dom";
// import { FaChevronDown, FaSignOutAlt, FaUser } from "react-icons/fa";
// import { HiMiniBars3CenterLeft } from "react-icons/hi2";
// import imgIcon from "../assets/images/userIcon.png";
// import { useAuth } from "../Context/AuthContext";

// const Topbar = () => {
//   const navigate = useNavigate();
//   const { logout,user } = useAuth(); // ✅ Using AuthContext logout

//   const [userRole, setUserRole] = useState(null);
//   const [showUserDropdown, setShowUserDropdown] = useState(false);
//   const [dailyTimecard, setDailyTimecard] = useState("N");
//   const [ticketTimecard, setTicketTimecard] = useState("N");
//   const [showProfileModal, setShowProfileModal] = useState(false);
//   const [userDetails, setUserDetails] = useState(null);

//   const username = localStorage.getItem("username");

//   const toggleUserDropdown = () => {
//     setShowUserDropdown((prev) => !prev);
//   };

//   // Load user details once from localStorage
//   useEffect(() => {
//     try {
//       const storedUser = JSON.parse(localStorage.getItem("userDetails"));
//       if (storedUser) {
//         setUserDetails(storedUser);
//         setUserRole(storedUser?.role || "N/A");
//         setDailyTimecard(storedUser?.dailyTimecard || "N");
//         setTicketTimecard(storedUser?.ticketTimecard || "N");
//       }
//     } catch (error) {
//       console.error("Failed to parse user data from localStorage", error);
//     }
//   }, []);

//   // ✅ Use logout from AuthContext instead of re-implementing it
//   const handleLogout = () => {
//     setShowUserDropdown(false);
//     logout(); // This will clear localStorage, setUser(null), and navigate to /login
//   };

//   const handleProfileButton = () => {
//     setShowUserDropdown(false);
//     navigate("/profile-page");
//   };

//   const handleToggleSideBar = () => {
//     document.body.classList.toggle("toggle-sidebar");
//   };

//   return (
//     <>
//       <div className="dashboard-header">
//         <div className="header-left">
//           <button className="menu-button" onClick={handleToggleSideBar} >
//             <HiMiniBars3CenterLeft className="bar-icon" />
//           </button>
//         </div>

//         <div className="header-center">
//           <h2 className="dashboard-title" onClick={()=>navigate('/home')} style={{cursor:"pointer"}}>MAVRO</h2>
//         </div>

//         <div className="header-right">
//           {username && (
//             <div className="user-dropdown-container">
//               <button className="user-button" onClick={toggleUserDropdown}>
//                 <img src={imgIcon} alt="user" className="img-fluid user-icon" />
//                 <span className="username">{username}</span>
//                 <FaChevronDown className="down-icon" />
//               </button>

//               {showUserDropdown && (
//                 <div className="user-dropdown">
//                   <div className="user-role">
//                     <p>Name:&nbsp;{username}</p>
//                     <p>Role:&nbsp;{user.roles.join(", ")}</p>
//                   </div>
//                   <button
//                     className="profile-dropdown-button"
//                     onClick={handleProfileButton}
//                   >
//                     <FaUser /> View Profile
//                   </button>

//                   <button
//                     className="logout-dropdown-button"
//                     onClick={handleLogout}
//                   >
//                     <FaSignOutAlt /> Logout
//                   </button>
//                 </div>
//               )}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* Profile Modal */}
//       {showProfileModal && userDetails && (
//         <div
//           className="modal-overlay"
//           onClick={() => setShowProfileModal(false)}
//         >
//           <div
//             className="profile-modal"
//             onClick={(e) => e.stopPropagation()} // prevent closing on modal click
//           >
//             <button
//               className="modal-close-icon"
//               onClick={() => setShowProfileModal(false)}
//             >
//               &times;
//             </button>
//             <h2>User Profile</h2>
//             <div className="profile-details">
//               <p><strong>User ID:</strong> {userDetails.userId}</p>
//               <p><strong>Organisation ID:</strong> {userDetails.organisationId}</p>
//               <p>
//                 <strong>Username:</strong>{" "}
//                 {userDetails.username
//                   ? userDetails.username.charAt(0).toUpperCase() +
//                     userDetails.username.slice(1)
//                   : ""}
//               </p>
//               <p><strong>Email:</strong> {userDetails.email}</p>
//               <p><strong>Role:</strong> {userDetails.role}</p>
//               <p>
//                 <strong>Daily Timecard:</strong>{" "}
//                 {userDetails.dailyTimecard === "Y" ? "Yes" : "No"}
//               </p>
//               <p>
//                 <strong>Ticket Timecard:</strong>{" "}
//                 {userDetails.ticketTimecard === "Y" ? "Yes" : "No"}
//               </p>
//               {userDetails.roles && (
//                 <p>
//                   <strong>All Roles:</strong> {userDetails.roles.join(", ")}
//                 </p>
//               )}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default Topbar;
